module.exports = __webpack_public_path__ + "img/mainmenu.9bf67147.png";